import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Observable, throwError } from "rxjs";
import { ApiService } from "./api.service";
import { catchError, map, shareReplay } from "rxjs/operators";


@Injectable({
  providedIn: "root"
})
export class TermsPrivacyService {
  API_URL: string = environment.apiURL;

  private privacyCache$: Observable<any>;
  private termsCache$: Observable<any>;

  constructor(private http: HttpClient, private apiService: ApiService) {}

  getTerms() {
    if (!this.termsCache$) {
      this.termsCache$ = this.getTermsAndConditions().pipe(shareReplay());
    }
    return this.termsCache$;
  }

  getPrivacy() {
    if (!this.privacyCache$) {
      this.privacyCache$ = this.getPrivacyPolicy().pipe(shareReplay());
    }
    return this.privacyCache$;
  }

  getTermsAndConditions(): Observable<any> {
    let urlPath =
      this.API_URL +
      "/admin/confap/legaldocuments?doc=title:Cloud Terms of Service";
    return this.apiService
      .doGetObservable(urlPath)
      .pipe(map(response => response));
  }

  getPrivacyPolicy() {
    let urlPath =
      this.API_URL + "admin/confap/legaldocuments?doc=title:Privacy Policy";
    return this.apiService
      .doGetObservable(urlPath)
      .pipe(map(response => response));
  }
}
